import React from 'react'
import { Box } from '@node-space/ui-components'

export const CustomerInfoSkeletonLoader = () => {
  return (
    <Box flexCol gap={24} align="center">
      <Box className="rounded-full bg-surface-static animate-pulse h-24 w-24"></Box>
      <Box className="rounded bg-surface-static animate-pulse h-24 w-full"></Box>
    </Box>
  )
}
